import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projects, LAYER_ORDER, categoryLabel } from '../data/portfolio';
import './Projects.css';

export const LayerTags = ({ active }) => (
  <span className="layer-tags" aria-label={`Layers: ${active.join(', ')}`}>
    {LAYER_ORDER.map((num) => (
      <span key={num} className={`layer-tag ${active.includes(num) ? 'on' : ''}`} aria-hidden="true">
        {num}
      </span>
    ))}
  </span>
);

const Projects = () => (
  <section id="work" className="work wrap">
    <div className="section-head">
      <h2 className="display display-xl">Shipped<span className="accent">.</span></h2>
      <p className="section-note">
        A cross-section of things in production. Each row lists the layers it touches —
        04 Mobile, 03 Interface, 02 Services, 01 Platform.
      </p>
    </div>

    <div className="work-list">
      {projects.map((project, i) => (
        <motion.a
          key={project.id}
          href={project.liveUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="work-row"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5, delay: i * 0.06 }}
        >
          <span className="work-num mono">/{String(i + 1).padStart(2, '0')}</span>
          <span className="work-title">
            <span className="work-name">{project.title}</span>
            <span className="work-meta mono">
              {project.year} · {categoryLabel[project.category]} · {project.liveLabel || project.liveUrl.replace(/^https?:\/\//, '').replace(/\/$/, '')}
            </span>
          </span>
          <span className="work-desc">{project.summary}</span>
          <LayerTags active={project.layers} />
          <span className="work-arrow" aria-hidden="true">↗</span>
        </motion.a>
      ))}
    </div>

    <div className="work-more">
      <span className="eyebrow">Screenshots, features &amp; store links</span>
      <Link to="/projects" className="btn">All projects &amp; case studies →</Link>
    </div>
  </section>
);

export default Projects;
